import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function GoalForm({ goal, onSubmit, onCancel, isLoading }) {
  const [form, setForm] = useState({
    name: goal?.name || '',
    description: goal?.description || '',
    target_amount: goal?.target_amount || '',
    current_amount: goal?.current_amount || 0,
    deadline: goal?.deadline || '',
    status: goal?.status || 'active',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, target_amount: parseFloat(form.target_amount) || 0, current_amount: parseFloat(form.current_amount) || 0 });
  };

  return (
    <Card className="mb-6 border border-emerald-100 shadow-sm bg-white">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{goal ? 'Edit Goal' : 'New Savings Goal'}</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label className="text-xs">Goal Name *</Label>
            <Input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. House Deposit" required />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Target Amount ($) *</Label>
            <Input type="number" value={form.target_amount} onChange={e => set('target_amount', e.target.value)} placeholder="50000" required min="0" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Current Savings ($)</Label>
            <Input type="number" value={form.current_amount} onChange={e => set('current_amount', e.target.value)} placeholder="0" min="0" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Target Date *</Label>
            <Input type="date" value={form.deadline} onChange={e => set('deadline', e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Status</Label>
            <Select value={form.status} onValueChange={v => set('status', v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
                <SelectItem value="paused">Paused</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Notes (optional)</Label>
            <Textarea value={form.description} onChange={e => set('description', e.target.value)} placeholder="Add notes..." className="h-10 resize-none text-sm" />
          </div>
          <div className="md:col-span-2 flex justify-end gap-2 pt-2 border-t border-slate-100">
            <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>Cancel</Button>
            <Button type="submit" className="bg-emerald-600 hover:bg-emerald-700" disabled={isLoading}>
              {isLoading ? 'Saving...' : goal ? 'Update Goal' : 'Create Goal'}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}